import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

interface Props {
  crumbs?: any[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppBreadcrumbs',
  props: {
    crumbs: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { crumbs: any[] };



const hideLastCrumb = computed(() => Number(props.crumbs?.length) > 2);
const isLast = (i: number) => i === Number(props.crumbs?.length) - 1;

return { __sfc: true,props, hideLastCrumb, isLast }
}

})